module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./~/mqtt/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 112
// module chunks = 73